import React, {Component} from 'react'
import logoSmart from '../../../assets/img/logo.png'
import {Card, Elevation, H5, H6} from "@blueprintjs/core"
import { Tooltip } from 'react-tippy'
import _ from 'lodash'

import {connect} from 'react-redux'
import moment from 'moment'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import Truncate from '../../Shared/Truncate'
import IconType from '../../Shared/IconType'
import DropDown from '../../Shared/DropDown'
import SocialIcons from '../../Shared/SocialIcons'
import numeral from 'numeral'

import axios from '../../../services/axios'
import storage from '../../../services/storage'
import { showMetrics } from '../../../config'

import Select, { components }  from 'react-select'
import random from "generate-random-data"

import 'react-lazy-load-image-component/src/effects/blur.css'
import './styles.css'

class Post extends Component {
  constructor( props ){
    super(props)

    this.state = {
      ...this.props,
      isOpenCategories: false,
      isOpenPromotions: false
    }

    this.onChangeCategory = this.onChangeCategory.bind(this)
    this.onChangePromotion = this.onChangePromotion.bind(this)

    this.selectCategory = this.selectCategory.bind(this)
    this.selectPromotion = this.selectPromotion.bind(this)
  }

  formatMetrics(metric, format){
    format = numeral(metric).format(metric > 100000 ? '0.0a' : format)
    return format.toUpperCase()
  }

  onChangePromotion({id}){
    storage.get('page')
    .then((page)=>{
      return axios.put(`brands/${page}/competitorPosts/${this.props.id}`, {
        promotion_id: id,
        is_brand: this.state.is_brand
      })
    }).then((response)=>{
      this.setState({
        promotion_id: id
      }, ()=>{
        //this.props.onChangeCategory(this.props.id, id)
      })
    }).catch((error)=>{
      console.log(error)
    })
  }

  onChangeCategory({id}){
    storage.get('page')
    .then((page)=>{
      return axios.put(`brands/${page}/competitorPosts/${this.props.id}`, {
        category_id: id,
        is_brand: this.state.is_brand
      })
    }).then((response)=>{
      this.setState({
        categoria_id: id
      }, ()=>{
        this.props.onChangeCategory(this.props.id, id)
      })
    }).catch((error)=>{
      console.log(error)
    })
  }

  selectCategory(){
    const { isOpenCategories } = this.state
    let selectCategory = _.find(this.props.categories, {id: this.state.categoria_id})
    selectCategory == undefined && (selectCategory = _.find(this.props.categories, {id: 1}))
    
    const options = _.map(this.props.categories, (category)=>{
      return {
        value: category.id,
        label: category.name,
        ...category
      }
    })

    return (
      <div className="postCategoriesMenuContainer">
        <DropDown
          disabled={!!this.props.lock}
          bsStyle='default'
          onClose={()=>(this.setState({isOpenCategories: false}))}
          onClick={()=>(!!this.props.lock ? this.props.onErrorPermissions() : this.setState({isOpenCategories: !isOpenCategories}))}
          title={!!selectCategory && selectCategory.name}
        >
          <Select 
            menuIsOpen={isOpenCategories}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            backspaceRemovesValue={false}
            tabSelectsValue={false}
            options={options} 
            components={{ 
              DropdownIndicator: null, 
              IndicatorSeparator: null,
              Control: (props)=>{
                return (
                  <div className='postCategoriesMenuControl'>
                    <components.Control {...props} />
                  </div>
                )
              },
              MenuList : (props)=>{
                return (
                  <div className="postCategoriesMenu">
                    {props.children}
                  </div>
                )
              },
              Option: ({ innerProps, isDisabled, data}) =>{
                return (
                  <div 
                    className='postCategoryOption'
                    onClick={()=>(this.onChangeCategory(data))} 
                    data-active={selectCategory.id == data.id}>
                    <Tooltip
                      style={{
                        width: '100%',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      title={data.name}
                      position="top"
                      trigger="mouseenter focus"
                    >
                      {data.name}
                    </Tooltip>
                  </div>
                )
              }
            }}
          />
        </DropDown>
      </div>
    )
  }

  selectPromotion(){
    const { isOpenPromotions } = this.state
    let selectPromotion = _.find(this.props.promotions, {id: this.state.promotion_id})
    selectPromotion == undefined && (selectPromotion = _.find(this.props.promotions, {id: 1}))
    
    const options = _.map(this.props.promotions, (category)=>{
      return {
        value: category.id,
        label: category.name,
        ...category
      }
    })

    return (
      <div className="postCategoriesMenuContainer">
        <DropDown
          disabled={!!this.props.lock}
          bsStyle='default'
          onClose={()=>(this.setState({isOpenPromotions: false}))}
          onClick={()=>(!!this.props.lock ? this.props.onErrorPermissions() : this.setState({isOpenPromotions: !isOpenPromotions}))}
          title={!!selectPromotion && selectPromotion.name}
        >
          <Select 
            menuIsOpen={isOpenPromotions}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            backspaceRemovesValue={false}
            tabSelectsValue={false}
            options={options} 
            components={{ 
              DropdownIndicator: null, 
              IndicatorSeparator: null,
              Control: (props)=>{
                return (
                  <div className='postCategoriesMenuControl'>
                    <components.Control {...props} />
                  </div>
                )
              },
              MenuList : (props)=>{
                return (
                  <div className="postCategoriesMenu">
                    {props.children}
                  </div>
                )
              },
              Option: ({ innerProps, isDisabled, data}) =>{
                return (
                  <div 
                    className='postCategoryOption'
                    onClick={()=>(this.onChangePromotion(data))} 
                    data-active={selectPromotion.id == data.id}>
                    <Tooltip
                      style={{
                        width: '100%',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      title={data.name}
                      position="top"
                      trigger="mouseenter focus"
                    >
                      {data.name}
                    </Tooltip>
                  </div>
                )
              }
            }}
          />
        </DropDown>
      </div>
    )
  }

  render () {
    return(
      <Card 
        interactive={false} 
        elevation={Elevation.TWO} 
        className="postContainerDashboard"
        style={!showMetrics() ? {
          height: '410px'
        } : {
          
        }}
        id={this.state.id}>
        <div className="postIcon">
          <SocialIcons
            type={this.state.is_brand ? (!!this.state.ins_media_type ? this.state.ins_media_type.toLowerCase() : this.state.post_type.toLowerCase()) : this.state.type.toUpperCase()} 
            provider={this.state.provider} 
          />
        </div>
        <div className="post">
          <div className="postTopContainer">
            <div className="postImage">
              <a href={this.state.link} target="_blank">
                <LazyLoadImage
                  effect='blur' 
                  src={this.state.picture} 
                  alt="" 
                />
              </a>
            </div>
            <div className="postExtras">
              <p className="postExtrasType"> 
                <IconType 
                  provider={this.state.provider}
                  type={this.state.is_brand ? this.state.post_type.toUpperCase() : this.state.type.toUpperCase()} 
                />
              </p>
              {this.state.is_brand && (
                <div className="postExtrasEngagment">
                  <H6>
                    ENG Score
                  </H6>
                  <p>
                    {this.formatMetrics(this.state.es_calculated, '0,0.000')}%
                  </p>
                </div>
              )}
              <div className="postExtrasEngagment">
                <H6>
                  ES Competition
                </H6>
                <p>
                  {this.formatMetrics(this.state.es_competition || this.state.score, '0,0.0000')}
                </p>
              </div>
              <div 
                className="postExtrasCategory">
                {this.selectCategory()}
              </div>
              <div 
                className="postExtrasCategory postExtrasPromotions">
                {this.selectPromotion()}
              </div>
            </div>
          </div>
          <div className="postMessage">
            <Truncate text={this.state.caption || this.state.message} />
          </div>
          <div className="postDate">
            <p> 
              <img 
                src={(this.props.is_brand ? this.props.competitor.picture : this.props.competitor.image) || logoSmart}
                alt="Logo Smart" 
                className="logoBrand" 
              />
              {moment(this.state.post_published_date).format("llll")}
            </p>
          </div>
          <div className="postInsights">
            <div className="postInsightsInfo">
              <H5>
                {(this.state.provider == 'instagram' || this.state.provider == 'facebook') ? 'REACH' : 'IMPRESSIONS'}
              </H5>
              <div className="postInsightsData">
                <div className="postDataItem">
                  <p className="postDataInfo">{this.formatMetrics(this.state.provider == 'instagram' ? this.state.post_impressions_organic_unique : this.state.post_impressions_organic, '0,0')}</p>
                  <p className="postDataTitle">Organic</p>
                </div>
                <div className="postDataItem">
                  <p className="postDataInfo">{this.formatMetrics(this.state.provider == 'instagram' ? this.state.post_impressions_paid_unique : this.state.post_impressions_paid, '0,0')}</p>
                  <p className="postDataTitle">Paid</p>
                </div>
                <div className="postDataItem">
                  <p className="postDataInfo">{this.formatMetrics(this.state.provider == 'instagram' ?  (this.state.post_impressions_organic_unique || 0) + (this.state.post_impressions_paid_unique || 0) : (this.state.post_impressions_organic || 0) + (this.state.post_impressions_paid || 0), '0,0')}</p>
                  <p className="postDataTitle">Total</p>
                </div>
              </div>
            </div>
            <div className="postInsightsInfo">
              <H5>
                ENGAGEMENT
              </H5>
              <div className="postInsightsData">
                <div className="postDataItem">
                  <p className="postDataInfo">{this.formatMetrics(this.state.is_brand ? (!!this.state.ins_media_type && this.state.ins_media_type.toLowerCase().includes('story') ? this.state.post_impressions_organic_unique : this.state.wow+this.state.likes+this.state.anger+this.state.haha+this.state.sorry+this.state.love+this.state.anger) : this.state.metrics.reactions, '0,0')}</p>
                  <p className="postDataTitle">{
                    !!this.state.ins_media_type && this.state.ins_media_type.toLowerCase().includes('story') 
                    ? 'Views'
                    : (this.state.provider == 'facebook' ? 'Reactions' : 'Likes')
                  }</p>
                </div>
                {this.state.provider != 'instagram' && (
                  <div className="postDataItem">
                    <p className="postDataInfo">{this.formatMetrics(this.state.is_brand ? this.state.shares : this.state.metrics.shares, '0,0')}</p>
                    <p className="postDataTitle">{
                        !!this.state.ins_media_type && this.state.ins_media_type.toLowerCase().includes('story') 
                        ? 'DM'
                        : (this.state.provider == 'twitter' ? 'RT’s' : 'Shares')
                    }</p>
                  </div>
                )}
                <div className="postDataItem">
                  <p className="postDataInfo">{this.formatMetrics(this.state.is_brand ? this.state.comments : this.state.metrics.comments, '0,0')}</p>
                  <p className="postDataTitle">{this.state.provider == 'twitter' ? 'Replies' : 'Comments'}</p>
                </div>
              </div>
            </div>
            {showMetrics() && (
              <div className="postInsightsInfo">
                <H5>
                  {this.state.provider == 'instagram' ? 'IMPRESSIONS' : 'CLICKS'}
                </H5>
                {(this.state.provider != 'twitter' && this.state.provider != 'instagram') && (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.linkclicks, '0,0')}</p>
                      <p className="postDataTitle">Links</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.photoclicks, '0,0')}</p>
                      <p className="postDataTitle">{
                          !!this.state.ins_media_type && this.state.ins_media_type.toLowerCase().includes('story') 
                          ? 'Tap BCK'
                          : 'Photo' 
                      }</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.otherclicks, '0,0')}</p>
                      <p className="postDataTitle">{
                          !!this.state.ins_media_type && this.state.ins_media_type.toLowerCase().includes('story') 
                          ? 'Tap FWD'
                          : 'Others'
                      }</p>
                    </div>
                  </div>
                )}
                {this.state.provider == 'twitter' && (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.user_profile_clicks, '0,0')}</p>
                      <p className="postDataTitle">Profile</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.paid_user_profile_clicks, '0,0')}</p>
                      <p className="postDataTitle">Paid Profile</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.promoted_permalink_clicks, '0,0')}</p>
                      <p className="postDataTitle">Perm Profile</p>
                    </div>
                  </div>
                )}
                {(this.state.provider == 'instagram') && (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.post_impressions_organic, '0,0')}</p>
                      <p className="postDataTitle">Organic</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.post_impressions_paid, '0,0')}</p>
                      <p className="postDataTitle">Paid</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.formatMetrics(this.state.post_impressions_paid + this.state.post_impressions_organic, '0,0')}</p>
                      <p className="postDataTitle">Total</p>
                    </div>
                  </div>
                )}
              </div>
            )}
            {(showMetrics()) && (
              <div className="postInsightsInfo">
                <H5>
                  VIEWS
                </H5>
                {(this.state.provider == 'facebook' || this.state.provider == 'ads-post') && (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.video_lto, '0,0') : '-'}</p>
                      <p className="postDataTitle">LTO 95%</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.videosviewspaid, '0,0') : '-'}</p>
                      <p className="postDataTitle">Paid Views</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.full_paid_views, '0,0') : '-'}</p>
                      <p className="postDataTitle">Full Paid Views</p>
                    </div>
                  </div>
                )}
                {(this.state.provider == 'instagram') && (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.videosviewsorganics || this.state.videosviews, '0,0', '0,0') : '-'}</p>
                      <p className="postDataTitle">View</p>
                    </div>
                  </div>
                )}
                {(this.state.provider == 'twitter')&& (
                  <div className="postInsightsData">
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.videosviewsorganics, '0,0') : '-'}</p>
                      <p className="postDataTitle">Organic</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.videosviewspaid, '0,0') : '-'}</p>
                      <p className="postDataTitle">Paid</p>
                    </div>
                    <div className="postDataItem">
                      <p className="postDataInfo">{this.state.post_type == 'video' ? this.formatMetrics(this.state.videosviewsorganics + this.state.videosviewspaid, '0,0') : '-'}</p>
                      <p className="postDataTitle">Total</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
    )
 }
}

const mapStateToProps = (state, ownProps) => {
  return {
    categories: state.categories.categories,
    promotions: state.promotions.promotions
 }
}

export default connect(
  mapStateToProps, null)(Post)



// WEBPACK FOOTER //
// ./src/components/ContentAnalytics/Post/Post.js